"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-d-aiano": {
    "3ae36ae7": [{
      "hkey": "d29abe17",
      "slug": "santa-maria-di-labante",
      "name": "Santa Maria di Labante",
      "primary": true,
      "skipSearch": false
    }],
    "labante": [{
      "hkey": "d29abe17",
      "slug": "santa-maria-di-labante",
      "name": "Santa Maria di Labante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f11a8361": [{
      "hkey": "c2b7775a",
      "slug": "villa-d-aiano-ca-del-costa",
      "name": "Villa d'Aiano-Ca' del Costa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-d-aiano": [{
      "hkey": "c2b7775a",
      "slug": "villa-d-aiano-ca-del-costa",
      "name": "Villa d'Aiano-Ca' del Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;